/* eslint-disable */

export default {
  hero: require("./hero.jpg"),
  logo: require("./logo.png"),
  headline: require("./headling_epic_chat_stories.png"),
  download: require("./download_on_mobile.png")
};



// WEBPACK FOOTER //
// ./src/images/index.js